export const defaultErrorMessage = 'Something went wrong'
